module.exports = __webpack_public_path__ + "img/t3.38eeb985.svg";